import { useState } from 'react'
import { Button } from '@heroui/react'

import landingPageImage from '../assets/cyrano_landing_page.png'

import { SignInModal, Footer } from './'

export const LandingPage = () => {
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)

  const handleSignIn = () => {
    setIsSignInModalOpen(true)
  }

  return (
    <div className="min-h-screen bg-gradient-custom-fixed flex flex-col">
      <div className="flex flex-col items-center justify-center flex-1 py-12 px-4">
        <div className="text-center space-y-6 max-w-2xl">
          {/* Title */}
          <h1 className="text-6xl text-foreground">
            <span className="font-bold text-primary">Cyrano</span>
            <span className="font-normal">, the </span>
            <span className="italic">soul</span>
            <span className="font-normal"> of wit</span>
          </h1>

          {/* Explainer text */}
          <p className="text-xl text-default-500 font-medium">
            The perfect gif for every occasion
          </p>

          {/* Image */}
          <div className="flex justify-center py-4">
            <img
              src={landingPageImage}
              alt="Cyrano App Preview"
              className="h-100 w-auto rounded-lg"
            />
          </div>

          {/* Sign up button */}
          <div>
            <Button
              color="primary"
              size="lg"
              radius="full"
              onPress={handleSignIn}
              className="px-12 py-3 text-lg"
            >
              Sign Up / Login
            </Button>
          </div>
        </div>
      </div>

      <Footer />

      <SignInModal
        isOpen={isSignInModalOpen}
        onOpenChange={setIsSignInModalOpen}
      />
    </div>
  )
}
